import { z } from 'zod';
import { AvailabilityBlockStates } from '@mews-commander/data-access';
import { Validation } from '@mews/framework';
import { FilterValueKey } from './constants';

export const availabilityBlockReportFiltersSchema = z.object({
    [FilterValueKey.startDate]: Validation.DateTime.Utc,
    [FilterValueKey.endDate]: Validation.DateTime.Utc,
    [FilterValueKey.serviceId]: z.string().nullish(),
    [FilterValueKey.states]: z.array(z.nativeEnum(AvailabilityBlockStates)).nullish(),
    [FilterValueKey.companyId]: z.string().nullish(),
    [FilterValueKey.travelAgencyId]: z.string().nullish(),
});

export type AvailabilityBlockReportFilterValues = z.infer<typeof availabilityBlockReportFiltersSchema>;
